<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="门店">
                  <GridSelectLi style="width: 200px" title="选择门店" labelName="storeName" labelValue="id"
                                :value="queryForm.storeId" :limit="1" size="small"
                                @getValue="getSearchValueStoreId"
                                :columns="STORE_code" :searchs="STORE_search" dataListUrl="/shop/store/findList" entityBeanName="shopStore" queryEntityUrl="/shop/store/get">
                  </GridSelectLi>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStorePaySubaccountList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopStorePaySubaccount"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopStorePaySubaccount(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopStorePaySubaccount(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopStorePaySubaccountList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopStorePaySubaccountList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="storeId"
        label="门店"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.store">
                  <div>{{ scope.row.store.storeName }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="subStoreId"
          label="分账门店"
          width="180"
        >
            <template slot-scope="scope">
                <div v-if="scope.row.subStore">
                    <div>{{ scope.row.subStore.storeName }}</div>
                </div>
                <div v-else>--</div>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="subAccount"
        label="支付平台子账号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="splitRatio"
        label="分账比例"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopStorePaySubaccount(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopStorePaySubaccount(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopStorePaySubaccount(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopStorePaySubaccountStates[shopStorePaySubaccountState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopStorePaySubaccount"
          ref="shopStorePaySubaccountForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="门店"
            prop="storeId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStorePaySubaccount.storeId"-->
<!--              :disabled="shopStorePaySubaccountState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectLi style="width: 200px" title="选择门店" labelName="storeName" labelValue="id"
                            :value="shopStorePaySubaccount.storeId" :limit="1" size="small" :disabled="shopStorePaySubaccountState == 'check'"
                            @getValue="getValueStoreId"
                            :columns="STORE_code" :searchs="STORE_search" dataListUrl="/shop/store/findList" entityBeanName="shopStore" queryEntityUrl="/shop/store/get">
              </GridSelectLi>
          </el-form-item>
            <el-form-item
                label="分账门店"
                prop="subStoreId"
            >
                <!--            <el-input-->
                <!--              size="small"-->
                <!--              v-model="shopStorePaySubaccount.storeId"-->
                <!--              :disabled="shopStorePaySubaccountState == 'check'"-->
                <!--            ></el-input>-->
                <GridSelectLi style="width: 200px" title="选择门店" labelName="storeName" labelValue="id"
                              :value="shopStorePaySubaccount.subStoreId" :limit="1" size="small" :disabled="shopStorePaySubaccountState == 'check'"
                              @getValue="getValueSubStoreId"
                              :columns="STORE_code" :searchs="STORE_search" dataListUrl="/shop/store/findList" entityBeanName="shopStore" queryEntityUrl="/shop/store/get">
                </GridSelectLi>
            </el-form-item>
          <el-form-item
            label="支付平台子账号"
            prop="subAccount"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStorePaySubaccount.subAccount"
              :disabled="shopStorePaySubaccountState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="分账比例"
            prop="splitRatio"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStorePaySubaccount.splitRatio"
              :disabled="shopStorePaySubaccountState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopStorePaySubaccountState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { STORE, STORE_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectLi,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopStorePaySubaccountList();
                    this.getShopStorePaySubaccountList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopStorePaySubaccountList();
                    this.getShopStorePaySubaccountList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     id: '', //
                     storeId: '', //门店id
                     subAccount: '', //支付平台子账号
                     splitRatio: '', //分账比例
                     subStoreId: '',
                },
                STORE_code: STORE,
                STORE_search: STORE_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopStorePaySubaccountState: 'add',
                shopStorePaySubaccountStates: {
                    add: '新建门店分账',
                    check: '查看门店分账',
                    edit: '修改门店分账'
                },

                multipleSelection: [],
                shopStorePaySubaccountList: [],
                shopStorePaySubaccount: {
                    id: '', //
                    storeId: '', //门店id
                    subAccount: '', //支付平台子账号
                    splitRatio: '', //分账比例
                    subStoreId: '',
                },
                btnLoading: false,

                rules: {
                    storeId: [{ required: true, message: '门店id不能为空', trigger: 'blur' }],
                    subStoreId: [{ required: true, message: '分账门店不能为空', trigger: 'blur' }],
                    subAccount: [{ required: true, message: '支付平台子账号不能为空', trigger: 'blur' }],
                    splitRatio: [{ required: true, message: '分账比例不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getShopStorePaySubaccountList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetShopStorePaySubaccountList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopStorePaySubaccountList = [];
            },
            getValueStoreId(val){
                this.shopStorePaySubaccount.storeId = val
            },
            getSearchValueStoreId(val) {
                this.queryForm.storeId = val;
            },
            getValueSubStoreId(val){
                this.shopStorePaySubaccount.subStoreId = val
            },
            resetDialog() {
                this.shopStorePaySubaccountState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      storeId: '', //门店id
                      subStoreId: '',
                      subAccount: '', //支付平台子账号
                      splitRatio: '', //分账比例
                };
                this.getShopStorePaySubaccountList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopStorePaySubaccount = {
                      id: '', //
                      subStoreId: '',
                      storeId: '', //门店id
                      subAccount: '', //支付平台子账号
                      splitRatio: '', //分账比例
                };
            },
            submitForm() {
                if (this.shopStorePaySubaccountState == 'add') {
                    this.$refs.shopStorePaySubaccountForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/storepaysubaccount/add`,{ ...this.shopStorePaySubaccount }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopStorePaySubaccountList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopStorePaySubaccountState == 'edit') {
                    this.$refs.shopStorePaySubaccountForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopStorePaySubaccount.store
                            delete this.shopStorePaySubaccount.subStore
                            post(`/shop/storepaysubaccount/edit`,{ ...this.shopStorePaySubaccount }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopStorePaySubaccountList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopStorePaySubaccount() {
                this.showDialog = true;
                this.shopStorePaySubaccountState = 'add';
            },
            checkShopStorePaySubaccount(shopStorePaySubaccountId) {
                console.log(shopStorePaySubaccountId);
                this.currentShopStorePaySubaccountId = shopStorePaySubaccountId;

                this.getShopStorePaySubaccountById();
                this.showDialog = true;
                this.shopStorePaySubaccountState = 'check';
            },
            editShopStorePaySubaccount(shopStorePaySubaccountId) {
                console.log('shopStorePaySubaccount', shopStorePaySubaccountId);
                if (shopStorePaySubaccountId) {
                    this.currentShopStorePaySubaccountId = shopStorePaySubaccountId;
                    this.getShopStorePaySubaccountById();
                } else {
                    this.shopStorePaySubaccount = { ...this.shopStorePaySubaccount, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopStorePaySubaccountState = 'edit';
            },
            deleteShopStorePaySubaccount(shopStorePaySubaccountId) {
                let ids = '';
                if (shopStorePaySubaccountId) {
                    ids = shopStorePaySubaccountId;
                } else {
                    ids = this.multipleSelection.map((shopStorePaySubaccount) => shopStorePaySubaccount.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/storepaysubaccount/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStorePaySubaccountList();
                                this.getShopStorePaySubaccountList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopStorePaySubaccountList() {
                this.resetShopStorePaySubaccountList();
                this.getShopStorePaySubaccountList();
            },
            getShopStorePaySubaccountList(query = {}) {
                this.loading = true;
                get(`/shop/storepaysubaccount/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopStorePaySubaccountList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopStorePaySubaccountById() {
                get(`/shop/storepaysubaccount/get`,{ id: this.currentShopStorePaySubaccountId }).then((res) =>{
                    if(res.success){
                      this.shopStorePaySubaccount = { ...this.shopStorePaySubaccount, ...res.shopStorePaySubaccount };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopStorePaySubaccountList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/storepaysubaccount/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/storepaysubaccount/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/storepaysubaccount/importData`,formData);
              this.refreshShopStorePaySubaccountList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopStorePaySubaccountList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopStorePaySubaccountList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>